import React from 'react'
import { storiesOf } from '@storybook/react'

import SocialShareLayer from 'components/SocialShareLayer'

storiesOf('SocialShareLayer', module)
  .add('default', () => {
    return <SocialShareLayer url="https://play.foosio.com" text="Hello Foosio!" subject="Foosio" onClose={() => null} />
  })
